import { render, staticRenderFns } from "./AdoptionReportPropagandistBook.vue?vue&type=template&id=1fbf4bc2&"
import script from "./AdoptionReportPropagandistBook.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportPropagandistBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports